import { Directive, ElementRef, Input, Renderer2, inject } from '@angular/core';
import { carregaSVG } from '../../core/utils/utils';

@Directive({
    selector: '[appIcone]',
    standalone: true,
})
export class IconeDirective {
    private element = inject(ElementRef);
    private renderer = inject(Renderer2);

    private readonly EXTENSAO_SVG: string = '.svg';
    private readonly ICONE_MEMORIA: Map<string, Element> = new Map();

    private nomeIcone: string = '';
    private fonteImagem: string = 'icons/outline/';

    @Input()
    public set appIcone(nomeIcone: string) {
        const alterarIcone: boolean = this.nomeIcone != nomeIcone;
        this.nomeIcone = nomeIcone;
        if (alterarIcone) {
            this.aoAlterarNomeIcone();
        }
    }

    private aoAlterarNomeIcone(): void {
        this.removeSVG();
        this.adicionaImagem();
    }

    private removeSVG(): void {
        const svgElement = this.element.nativeElement.querySelector('svg');
        if (svgElement) {
            this.renderer.removeChild(this.element.nativeElement, svgElement);
        }
    }

    private adicionaImagem(): void {
        const svgElement = this.ICONE_MEMORIA.get(this.nomeIcone);
        if (svgElement) {
            this.renderer.appendChild(this.element.nativeElement, svgElement);
        } else {
            this.carregaSVG();
        }
    }

    private async carregaSVG(): Promise<void> {
        try {
            const svgText = await carregaSVG(this.nomeIcone + this.EXTENSAO_SVG, this.fonteImagem);
            if (svgText) {
                this.aoCarregarSVG(svgText);
            }
        } catch (error) {
            console.error('Erro ao carregar o SVG:', error);
        }
    }

    private aoCarregarSVG(svgText: string): void {
        const tempDiv = this.renderer.createElement('div');
        tempDiv.innerHTML = svgText.trim();

        const svgElement = tempDiv.querySelector('svg');
        if (svgElement) {
            this.ICONE_MEMORIA.set(this.nomeIcone, svgElement);
            this.renderer.appendChild(this.element.nativeElement, svgElement);
        }
    }
}
